import { FC } from "react";
import { Box, Button } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { FormikValues, useFormikContext } from "formik";

import useAppStore from "../../../../states/zustand/appStore";
import SubmitConfirmationModal from "../../confirmationModal/SubmitConfirmationModal/SubmitConfirmation";

interface IProps {
  setSteps: (newStep: any) => void;
  steps: number;
  stepsInfo: string[];
  id?: string;
}

const CreatePageFormFooter: FC<IProps> = (props) => {
  const { handleSubmit, isValid } = useFormikContext<FormikValues>();
  const { setSteps, steps, stepsInfo, id } = props;

  const { setIsSubmitModalVisible } = useAppStore((state) => state);

  const openConfirmationModal = () => {
    if (steps === stepsInfo.length - 1 && isValid) {
      return setIsSubmitModalVisible(true);
    } else {
      handleSubmit()
    }
  };

  const navigate = useNavigate();

  const cancelClickHandler = () => {
    navigate(-1);
  };

  const backClickHandler = () => {
    if (steps > 0) {
      setSteps((prev: number) => +prev - 1);
    }
  };

  return (
    <Box className="d-flex justify-content-center align-items-center mg-t-60">
      <Button
        variant={"outlined"}
        color={"error"}
        className="mg-r-10"
        type="button"
        onClick={cancelClickHandler}
      >
        Cancel
      </Button>

      <Button
        variant={"outlined"}
        color={"error"}
        className="mg-r-10"
        type="button"
        onClick={backClickHandler}
      >
        <ArrowBack className="mg-r-6" sx={{ width: "1rem", height: "1rem" }} />
        <span>Back</span>
      </Button>

      <Button
        variant={"contained"}
        color={"error"}
        type="button"
        onClick={() => openConfirmationModal()}
      >
        {steps === stepsInfo.length - 1 ? "Submit" : "Next"}
      </Button>
      <SubmitConfirmationModal callBack={() => handleSubmit()} />
    </Box>
  );
};

export default CreatePageFormFooter;
